
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!assignments.index_view";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'assignments/IndexView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <h2 class=\"screenreader-only\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments", "Assignments", options) : helperMissing.call(depth0, "t", "assignments", "Assignments", options)))
    + "\n  </h2>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <h1 class=\"screenreader-only\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments", "Assignments", options) : helperMissing.call(depth0, "t", "assignments", "Assignments", options)))
    + "\n  </h1>\n";
  return buffer;
  }

function program5(depth0,data) {
  
  
  return "\n  <div id=\"bulkEditRoot\"></div>\n";
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n\n<div tabindex=\"0\" class=\"drag_and_drop_warning screenreader-only\">\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "warning_for_improved_accessibility_of_reordering_a_5d0206c7", "Warning: for improved accessibility of reordering assignments and groups, please use the Move To Dialog option found in the menu.", options) : helperMissing.call(depth0, "t", "warning_for_improved_accessibility_of_reordering_a_5d0206c7", "Warning: for improved accessibility of reordering assignments and groups, please use the Move To Dialog option found in the menu.", options)))
    + "\n</div>\n<div class=\"header-bar\">\n  <div class=\"header-bar-left ic-Form-control assignment-search\">\n    <div class=\"ic-Multi-input\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.HAS_GRADING_PERIODS), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <label for=\"search_term\" class=\"screenreader-only\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "search_for_assignment", "Search for Assignment", options) : helperMissing.call(depth0, "t", "search_for_assignment", "Search for Assignment", options)))
    + "\n      </label>\n      <input\n        class=\"ic-Input\"\n        id=\"search_term\"\n        name=\"search_term\"\n        type=\"search\"\n        value=\"\"\n        disabled\n        placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "search_for_assignment", "Search for Assignment", options) : helperMissing.call(depth0, "t", "search_for_assignment", "Search for Assignment", options)))
    + "\"\n      >\n    </div>\n  </div>\n\n  <div class=\"header-bar-right\">\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments), {hash:{},inverse:self.program(14, program14, data),fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n\n<div data-view=\"assignmentGroups\" class=\"item-group-container\" id=\"ag-list\"></div>\n<div id=\"copy-to-mount-point\" />\n<div id=\"send-to-mount-point\" />\n<div id=\"external-tool-mount-point\" />\n\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <select class=\"ic-Input\" id=\"grading_period_selector\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "select_a_grading_period_aab25483", "Select a Grading Period", options) : helperMissing.call(depth0, "t", "select_a_grading_period_aab25483", "Select a Grading Period", options)))
    + "\">\n          <option value=\"all\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "all_grading_periods_77974940", "All Grading Periods", options) : helperMissing.call(depth0, "t", "all_grading_periods_77974940", "All Grading Periods", options)))
    + "</option>\n          ";
  stack1 = helpers.each.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.active_grading_periods), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </select>\n      ";
  return buffer;
  }
function program9(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n            <option id=\"grading_period_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" value=\""
    + escapeExpression(((stack1 = (data == null || data === false ? data : data.index)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</option>\n          ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.QUIZ_LTI_ENABLED), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n      <a\n        href=\"#\"\n        class=\"btn icon-plus\"\n        id=\"addGroup\"\n        role=\"button\"\n        title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "title_add_group", "Add Assignment Group", options) : helperMissing.call(depth0, "t", "title_add_group", "Add Assignment Group", options)))
    + "'\n        aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "title_add_group", "Add Assignment Group", options) : helperMissing.call(depth0, "t", "title_add_group", "Add Assignment Group", options)))
    + "'\n      >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "add_group", "Group", options) : helperMissing.call(depth0, "t", "add_group", "Group", options)))
    + "</a>\n\n      <a\n        href=\""
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.URLS)),stack1 == null || stack1 === false ? stack1 : stack1.new_assignment_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n        class=\"new_assignment btn btn-primary icon-plus\"\n        role=\"button\"\n        title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "title_add_assignment", "Add Assignment", options) : helperMissing.call(depth0, "t", "title_add_assignment", "Add Assignment", options)))
    + "'\n        aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "title_add_assignment", "Add Assignment", options) : helperMissing.call(depth0, "t", "title_add_assignment", "Add Assignment", options)))
    + "'\n      >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "add_assignment", "Assignment", options) : helperMissing.call(depth0, "t", "add_assignment", "Assignment", options)))
    + "</a>\n\n      <span id=\"settingsMountPoint\"></span>\n    ";
  return buffer;
  }
function program12(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <span class=\"new_quiz_lti_wrapper\">\n          <a\n            href=\""
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.URLS)),stack1 == null || stack1 === false ? stack1 : stack1.new_assignment_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "?quiz_lti\"\n            class=\"new_quiz_lti btn icon-plus\"\n            role=\"button\"\n            title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "title_add_quiz_lti", "Add Quiz/Test", options) : helperMissing.call(depth0, "t", "title_add_quiz_lti", "Add Quiz/Test", options)))
    + "'\n            aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "title_add_quiz_lti", "Add Quiz/Test", options) : helperMissing.call(depth0, "t", "title_add_quiz_lti", "Add Quiz/Test", options)))
    + "'\n          >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "add_quiz_lti", "Quiz/Test", options) : helperMissing.call(depth0, "t", "add_quiz_lti", "Quiz/Test", options)))
    + "</a>\n        </span>\n      ";
  return buffer;
  }

function program14(depth0,data) {
  
  
  return "\n      <div data-view=\"showBy\"></div>\n    ";
  }

function program16(depth0,data) {
  
  
  return "\n  <form data-view=\"createGroup\" class=\"form-dialog\"></form>\n  <form data-view=\"assignmentSettings\" class=\"form-dialog\"></form>\n  <form data-view=\"assignmentSyncSettings\" class=\"form-dialog\"></form>\n";
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.course_home), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.bulkEditMode), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  